// src/context/ServiceStatusContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { getServiceStatus } from '../services/serviceStatus';

// Create context
const ServiceStatusContext = createContext();

// Custom hook to use the context
export const useServiceStatus = () => useContext(ServiceStatusContext);

export const ServiceStatusProvider = ({ children }) => {
  const [serviceStatus, setServiceStatus] = useState({
    isLoading: true,
    serviceDown: false,
    lastChecked: null
  });

  // Function to check service status
  const checkServiceStatus = async () => {
    try {
      // Use the service function instead of direct axios call
      const status = await getServiceStatus();
      
      setServiceStatus({
        isLoading: false,
        serviceDown: status.serviceDown,
        lastChecked: new Date()
      });
    } catch (error) {
      console.error('Error checking service status:', error);
      // Default to service up in case of error
      setServiceStatus({
        isLoading: false,
        serviceDown: false,
        lastChecked: new Date()
      });
    }
  };

  // Check service status on initial load
  useEffect(() => {
    checkServiceStatus();
    
    // Set up a periodic check every 5 minutes
    const intervalId = setInterval(checkServiceStatus, 5 * 60 * 1000);
    
    // Clean up interval on unmount
    return () => clearInterval(intervalId);
  }, []);

  // Method to manually refresh the status
  const refreshStatus = () => {
    setServiceStatus(prev => ({ ...prev, isLoading: true }));
    checkServiceStatus();
  };

  // Value to provide through the context
  const value = {
    ...serviceStatus,
    refreshStatus
  };

  return (
    <ServiceStatusContext.Provider value={value}>
      {children}
    </ServiceStatusContext.Provider>
  );
};

export default ServiceStatusContext;